export const version = "bignumber/5.6.0";
//# sourceMappingURL=_version.js.map